import { Component, OnDestroy, OnInit } from "@angular/core";
import { Contact, ContactField, Cryptocoin, Time } from "@models";
import { ContactComponent } from "@modules/main/components/contact/contact.interface";
import { CryptocoinService } from "@main-services/currency/cryptocoin.service";
import { Helper } from "@helpers/functions";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { ContactService } from "@main-services/contact.service";
import { InvitationService } from "@main-services/invitation.service";
import { UserService } from "@main-services/user.service";
import { InfoService } from "@core-services/info.service";
import { ConfirmModalService } from "@core-services/confirm-modal.service";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { SendEntryPointService } from "@modules/+new/payments/features/send/domain/send-entry-point.service";
import { TranslationService } from "@core-services/translation.service";

@Component({
	templateUrl: "./contact-edit.component.html",
	styleUrls: ["./contact-edit.component.scss"],
	standalone: false
})
export class ContactEditComponent extends ContactComponent implements OnInit, OnDestroy, BpModalHasSave {
	private objectCopy = null;
	public inviteButtonText: string = "invite_now_contact";
	public selectedIds: string[] = []; // Saves and updates all currently selected coins on the data object

	public constructor(
		protected readonly contactService: ContactService,
		protected readonly infoService: InfoService,
		protected readonly userService: UserService,
		protected readonly coinService: CryptocoinService,
		protected readonly tafService: InvitationService,
		protected readonly confirmModalService: ConfirmModalService,
		protected readonly sendEntryPoint: SendEntryPointService,
		protected readonly translationService: TranslationService
	) {
		super(contactService, infoService, userService, coinService, sendEntryPoint, translationService);
	}

	public ngOnInit(): void {
		this.objectCopy = JSON.stringify(this.data);
		this.updateSelectedIds();
	}

	public updateSelectedIds(): void {
		const tempIds: string[] = [];
		this.data.getFields(false, false).forEach((field) => {
			const coinSymbol: string = field.getType().split("_")[0];
			const coin: Cryptocoin = this.coinService.findBySymbol(coinSymbol);
			tempIds.push(coin.getId());
		});
		this.selectedIds = tempIds;
	}

	public ngOnDestroy(): void {
		const objectRestore: Contact = new Contact();
		Object.assign(objectRestore, JSON.parse(this.objectCopy));

		const contactFieldArray: ContactField[] = [];
		objectRestore.getPlainFields().forEach((f) => {
			const temp: ContactField = new ContactField();
			Object.assign(temp, f);

			const lastUsed: Time = new Time();
			Object.assign(lastUsed, f["last_used"]);
			temp.setLastUsed(lastUsed);

			contactFieldArray.push(temp);
		});

		this.data.setName(objectRestore.getName());
		this.data.setFields(contactFieldArray);

		const filteredFields = this.data.getFields(false, true);

		filteredFields.forEach((f) => {
			const initField = contactFieldArray.find((n) => n.getId() === f.getId());
			if (f.getName() !== initField.getName()) {
				f.setName(initField.getName());
			}
		});
	}

	public sendTaf(): void {
		this.tafService.taf.email = this.data.getEmail();
		this.tafService.tellAFriend().subscribe(
			() => this.startButtonTimer(),
			(e) => Helper.handleError(e, this.data)
		);
	}

	public startButtonTimer(): void {
		this.inviteButtonText = "sending_invite_contacts";
		let time: number = 3;
		const timer = window.setInterval(() => {
			if (--time <= 0) {
				clearInterval(timer);
				if (!this.data.hasError("email")) {
					this.inviteButtonText = "invite_more_contacts";
				}
			}
		}, 1000);
	}

	public addNewAddress(): void {
		const contactField = new ContactField(this.coinFilter()[0].value);
		this.data.addField(contactField);
		this.updateSelectedIds();
	}

	public deleteByObject(fields: ContactField[], field: ContactField): void {
		this.data.setFields(this.data.getFields(false, true).filter((f) => f !== field));
		this.updateSelectedIds();
	}

	public coinFilter(): BpSelectOption[] {
		return this.types.filter((type) => !this.data.getFields().some((field) => field.getType() === type.value));
	}

	public delete(): void {
		this.confirmModalService
			.showConfirmModal(
				"really_delete_contact_title",
				"really_delete_contact",
				"really_delete_contact_button_delete_now",
				"cancel"
			)
			.subscribe((yes) => {
				if (yes) {
					this.contactService.deleteContact(this.data);
					this.modalService.popAll();
				}
			});
	}
}
